<template>
  <v-container>
    <Loader :esActiva="mostrar_loader"/>
    <v-card
        elevation=""
        class="px-7 mt-3 pt-2 pb-5"
    >
        <v-form  ref="form" v-model="usuario.valido">   
        <v-text-field
            v-model="usuario.nombre"
            label="*RAZÓN SOCIAL / NOMBRE"
            prepend-inner-icon="mdi-account-outline"
            :rules="[v => !!v || 'RAZÓN SOCIAL / NOMBRE es obligatorio']"
        ></v-text-field>

        <v-text-field
            v-model="usuario.rut"
            label="RUT / DOCUMENTO"
            onkeypress="return event.charCode != 32"
            prepend-inner-icon="mdi-account-outline"
        ></v-text-field>

        <v-text-field
            v-model="usuario.direccion"        
            :rules="[v => !!v || 'La DIRECCIÓN es obligatoria']"
            @click="$router.push('/confirmar_ubiacion')"
            label="*TU DIRECCIÓN"
            prepend-inner-icon="mdi-google-maps"
        >
            <template v-slot:append>
            <v-btn
                class="mb-2 mr-1"
                fab
                dark
                read
                small
                @click="$router.push('/confirmar_ubiacion')"
                color="primary"
            >
                <v-icon dark>
                mdi-map-search-outline
                </v-icon>
            </v-btn>
            </template>
        </v-text-field>     
        </v-form>
    </v-card>
    <v-footer absolute class="font-weight-medium" padless>
      <v-btn x-large color="#58C4B5" dark style="width: 100%;" :style="{ 'opacity': `${opacidad}`}"
      @click="submit()" >MODIFICAR</v-btn>
    </v-footer>
  </v-container>
</template>

<script>
import Usuario from "@/objetos/usuario";
import Loader from '@/components/Loader/Loader.vue';
import Conexion_api from "@/api/Conexion_api.js";
import Vista from "@/objetos/vista";
//import returnToURL from '@/funciones/redireccionar2.js'
import CrossSiteRedirect from '@/../../frontend_pedidos_web/src/funciones/app/cross_site_redirect.js'

export default {
  name: "ModificarDatos",
  components: {
    Loader  
    },  
  data: () => ({
    alert: true,
    usuario: Usuario,
    icon_alert: "",
    color_alert: "",
    mostrar_loader: false,
  }),
  computed: {
    opacidad: function () {
      if (this.usuario.valido){
          return 1;
      }
      return 0.7
    }
  },  
  created(){
    Vista.nombre = "/modificar_datos";
  }, 
  methods: {
    clear() {
      this.$refs.form.reset();
    },
    submit() {
      var err = ""
      if(this.usuario.valido){
        this.mostrar_loader = true
        var razon_social = this.usuario.nombre.replace(/\s+/g, '');
        if(razon_social.length  <= 0){
            err = "La razón social no puede estar vacía"
            this.mostrar_loader = false
            this.$root.$emit('snackbar',{ color:"error", texto: err})
            return;
        }

		/*
		14/12/2021 - pedido por Federico, el campo RUT debe permitirse vacío
		https://redmine.pwstasp.com.uy/issues/346281

        var rut = (this.usuario.rut||"").replace(/\s+/g, '');
        if(rut.length  <= 0){
            err = "El rut no puede estar vacío"
            this.mostrar_loader = false
            this.$root.$emit('snackbar',{ color:"error", texto: err})
            return;
        }
		*/

        var direccion = this.usuario.direccion.replace(/\s+/g, '');
        if(direccion.length  <= 0){
            err = "La dirección no puede estar vacía"
            this.mostrar_loader = false
            this.$root.$emit('snackbar',{ color:"error", texto: err})
            return;
        }

        Conexion_api({
          body: {
              ...this.usuario
          },
          evento: "login/modificar_usuario"
        })
        .then(respuesta => { 
            this.mostrar_loader = false              
            if (respuesta.data.error) {
                console.error(respuesta.data.error);
                this.$root.$emit('snackbar',{ color:"error", texto: respuesta.data.error})   
                return;
            }

            this.$cookie.delete("pwst");
            Usuario.coordenadas = respuesta.data.usuario.coordenadas
            Usuario.nombre = respuesta.data.usuario.nombre
            Usuario.nombre_vista = respuesta.data.usuario.nombre
            Usuario.direccion = respuesta.data.usuario.direccion
            Usuario.rut = respuesta.data.usuario.rut

            this.$cookie.set('pwst', respuesta.data.token, { expires: '1h' });

            CrossSiteRedirect.goBack(this);
        })
        .catch(err => {
            this.mostrar_loader = false
            err = String(err);
            this.$root.$emit('snackbar',{ color:"error", texto: err})
            console.error(err);
        });
      }
    }    
  },
};
</script>